export default __webpack_public_path__ + "static/media/star-way.aae43fb1.wav";